import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Spinner } from 'components';
import { removeCarouselItem, uploadCarouselImages, uploadCarouselVideo } from 'redux/modules/adBuilder';
var maxCarouselItems = 10;

function CarouselItemUploadSection(props) {
  var multiple = props.multiple,
      video = props.video,
      carouselItems = props.carouselItems,
      uploadingFile = props.uploadingFile,
      uploadCarouselImages = props.uploadCarouselImages,
      uploadCarouselVideo = props.uploadCarouselVideo,
      remove = props.removeCarouselItem,
      organization = props.organization,
      onChange = props.onChange;

  var handleDrop = function handleDrop(files) {
    if (files && files.length > 0) {
      if (!video) {
        uploadCarouselImages(files, organization.id).then(function () {
          if (onChange) {
            onChange(carouselItems.map(function (item) {
              return item.fullyQualifiedUrl;
            }));
          }
        })["catch"](function (err) {
          console.error(err);
        });
      } else {
        uploadCarouselVideo(files, organization.id).then(function (result) {
          var newItems = [].concat(_toConsumableArray(carouselItems), _toConsumableArray(result.data));

          if (onChange) {
            onChange(newItems.map(function (item) {
              return item.fullyQualifiedUrl;
            }));
          }
        })["catch"](function (err) {
          console.error(err);
        });
      }
    }
  };

  var dropzone = carouselItems.length >= maxCarouselItems ? '' : /*#__PURE__*/React.createElement(Dropzone, {
    multiple: multiple,
    onDrop: handleDrop,
    accept: !video ? 'image/*' : 'video/mp4,video/x-m4v,video/*',
    style: {
      width: 120,
      height: 120,
      borderColor: '#8b8b8b',
      borderRadius: 4,
      border: '1px dashed #8b8b8b'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      position: 'relative',
      top: '25%',
      color: '#8b8b8b',
      fontSize: 13,
      padding: 8
    }
  }, "Drag and drop a", !video ? 'n image' : ' video', " here or click to upload."));
  var renderedCarouselItems = props.carouselItems.map(function (item, idx) {
    var url = item.fullyQualifiedUrl;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative'
      },
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#8b8b8b',
        borderStyle: 'solid',
        position: 'absolute',
        top: '-10px',
        left: '-10px',
        width: 25,
        height: 25,
        lineHeight: '25px',
        borderRadius: '50%',
        display: 'inline-block',
        cursor: 'pointer'
      },
      onClick: function onClick() {
        remove(url, organization.id);

        if (onChange) {
          onChange(props.carouselItems.filter(function (img) {
            return img === url;
          }));
        }
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "icon ion-ios-close-empty",
      style: {
        color: '#8b8b8b',
        fontSize: 25,
        lineHeight: '24px',
        width: '100%',
        display: 'inline-block',
        textAlign: 'center'
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundImage: "url(".concat(url, ")"),
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        marginRight: 16,
        width: 120,
        height: 120,
        cursor: 'pointer',
        borderColor: '#DBDBDB',
        borderWidth: '0.5px',
        borderStyle: 'solid',
        borderRadius: '4px'
      }
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 125,
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, renderedCarouselItems, uploadingFile ? /*#__PURE__*/React.createElement(Spinner, {
    center: true
  }) : dropzone);
}

function mapStateToProps(state) {
  var orgId = state.organization.current.id;
  return {
    carouselItems: state.adBuilder["".concat(orgId)] && state.adBuilder["".concat(orgId)].carouselItems ? state.adBuilder["".concat(orgId)].carouselItems : [],
    uploadingFile: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].uploadingFile : [],
    organization: state.organization.current
  };
}

CarouselItemUploadSection.propTypes = {
  multiple: PropTypes.bool.isRequired,
  video: PropTypes.bool.isRequired,
  carouselItems: PropTypes.array.isRequired,
  removeCarouselItem: PropTypes.func.isRequired,
  uploadCarouselImages: PropTypes.func.isRequired,
  uploadCarouselVideo: PropTypes.func.isRequired,
  uploadingFile: PropTypes.bool.isRequired
};
var actionCreators = {
  removeCarouselItem: removeCarouselItem,
  uploadCarouselImages: uploadCarouselImages,
  uploadCarouselVideo: uploadCarouselVideo
};
export default connect(mapStateToProps, actionCreators)(CarouselItemUploadSection);